import { entrances } from '@/mocks/chiguaData';

const toneMap: Record<string, { bubble: string; ring: string; cta: string }> = {
  primary: {
    bubble: 'bg-primary-100 text-primary-700',
    ring: 'group-hover:ring-primary-200',
    cta: 'bg-primary-500 text-background-50 hover:bg-primary-600',
  },
  accent: {
    bubble: 'bg-accent-100 text-accent-700',
    ring: 'group-hover:ring-accent-200',
    cta: 'bg-accent-500 text-background-50 hover:bg-accent-600',
  },
  secondary: {
    bubble: 'bg-secondary-100 text-secondary-800',
    ring: 'group-hover:ring-secondary-200',
    cta: 'bg-secondary-500 text-background-50 hover:bg-secondary-600',
  },
};

export default function Entrances() {
  return (
    <section id="entrance" className="bg-background-100/70 py-16 md:py-24 scroll-mt-20">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <div className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-door-open-line text-lg"></i>入口资源页
            </div>
            <h2 className="mt-3 font-heading text-3xl md:text-[40px] font-black leading-snug text-foreground-950">
              官网入口 · 最新地址 · 备用入口
            </h2>
            <p className="mt-3 max-w-2xl text-foreground-600 text-base leading-relaxed">
              认准这一页，入口永远有备选。官网入口打不开时，最新地址与备用入口随时候命，让你随时吃上新瓜。
            </p>
          </div>
          <div className="shrink-0 flex items-center gap-2 text-sm text-foreground-500">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            全线路在线检测中
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {entrances.map((e, i) => {
            const t = toneMap[e.tone];
            return (
              <article
                key={e.key}
                className={`group relative rounded-3xl bg-background-50 border border-background-200 p-6 md:p-8 transition-all ring-0 ring-2 ring-transparent ${t.ring}`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center ${t.bubble}`}
                  >
                    <i className={`${e.icon} text-2xl md:text-[26px]`}></i>
                  </span>
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-foreground-600">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                    {e.status}
                  </span>
                </div>

                <div className="mt-2 text-sm text-foreground-400">0{i + 1}</div>
                <h3 className="mt-1 font-heading text-2xl md:text-[26px] font-bold text-foreground-950">
                  {e.name}
                </h3>
                <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-foreground-600">{e.desc}</p>

                <div className="mt-7 flex items-center justify-between">
                  <span
                    className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${t.cta}`}
                  >
                    {e.action}
                    <i className="ri-arrow-right-line text-base"></i>
                  </span>
                  <i className="ri-external-link-line text-xl text-background-300 group-hover:text-background-400 transition-colors"></i>
                </div>
              </article>
            );
          })}
        </div>

        <p className="mt-8 text-center text-sm text-foreground-500">
          提示：请将本页加入收藏，网址一旦变动，以本页「最新地址」为准。
        </p>
      </div>
    </section>
  );
}